/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.2.0 (NJsonSchema v10.3.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { Router } from "@angular/router";
export class BackendClientBase {
    public token: string = null;

    constructor(private _router: Router) { }

    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        if (this.token) {
            options.headers["Authorization"] = `Bearer ${this.token}`
        }

        return Promise.resolve(options);
    }

    protected async transformResult(url: string, response: Response, processor: (resp: Response) => Promise<any>): Promise<any> {
        const clone = response.clone();
        const text = await clone.text();
        if (!text) {
            return await processor(response);
        }

        try {
            const redirect = RedirectModel.fromJS(JSON.parse(text));

            if (redirect?.redirectUrl) {
                console.log("redirecting to: ", redirect.redirectUrl)
                await this._router.navigate([redirect.redirectUrl]);

                throw new RequestRedirectError(redirect.redirectUrl);
            }
        }
        catch (e) {
            if (e instanceof RequestRedirectError) {
                throw e;
            }
        }

        return await processor(response);
    }
}

export class AccountClient extends BackendClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Router, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(model: LoginModel): Promise<JwtAuthResult> {
        let url_ = this.baseUrl + "/api/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogin(_response));
        });
    }

    protected processLogin(response: Response): Promise<JwtAuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtAuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtAuthResult>(<any>null);
    }

    register(model: RegisterModel): Promise<void> {
        let url_ = this.baseUrl + "/api/account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegister(_response));
        });
    }

    protected processRegister(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    refresh(model: RefreshModel): Promise<JwtAuthResult> {
        let url_ = this.baseUrl + "/api/account/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefresh(_response));
        });
    }

    protected processRefresh(response: Response): Promise<JwtAuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JwtAuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtAuthResult>(<any>null);
    }
}

export class DashboardClient extends BackendClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Router, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    home(): Promise<UserDashboard> {
        let url_ = this.baseUrl + "/api/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHome(_response));
        });
    }

    protected processHome(response: Response): Promise<UserDashboard> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
            let result302: any = null;
            let resultData302 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result302 = RedirectModel.fromJS(resultData302);
            return throwException("A server side error occurred.", status, _responseText, _headers, result302);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDashboard.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDashboard>(<any>null);
    }
}

export class ModulesClient extends BackendClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Router, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    updateModule(moduleId: number, state: DbModuleStates, sender: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/{state}?";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state));
        if (sender !== undefined && sender !== null)
            url_ += "sender=" + encodeURIComponent("" + sender) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateModule(_response));
        });
    }

    protected processUpdateModule(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    fileActionPlan(moduleId: number, actionPlan: { [key: string]: any; }): Promise<boolean> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/plan";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actionPlan);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFileActionPlan(_response));
        });
    }

    protected processFileActionPlan(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getModulePlan(moduleId: number): Promise<ModuleResource> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/plan";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModulePlan(_response));
        });
    }

    protected processGetModulePlan(response: Response): Promise<ModuleResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleResource.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResource>(<any>null);
    }

    fileActionReview(moduleId: number, review: { [key: string]: any; }): Promise<boolean> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/review";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(review);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFileActionReview(_response));
        });
    }

    protected processFileActionReview(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getModuleReview(moduleId: number): Promise<ModuleResource> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/review";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModuleReview(_response));
        });
    }

    protected processGetModuleReview(response: Response): Promise<ModuleResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleResource.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResource>(<any>null);
    }

    getModule(moduleId: number): Promise<Module> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModule(_response));
        });
    }

    protected processGetModule(response: Response): Promise<Module> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Module.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Module>(<any>null);
    }

    recordModuleResourceView(moduleId: number, resourceId: number, ref: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/{resourceId}/view?";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        if (ref !== undefined && ref !== null)
            url_ += "ref=" + encodeURIComponent("" + ref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecordModuleResourceView(_response));
        });
    }

    protected processRecordModuleResourceView(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    recordModuleResourceClose(moduleId: number, resourceId: number, ref: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/{resourceId}/close?";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        if (ref !== undefined && ref !== null)
            url_ += "ref=" + encodeURIComponent("" + ref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecordModuleResourceClose(_response));
        });
    }

    protected processRecordModuleResourceClose(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    recordModuleResourceVideoFinish(moduleId: number, ref: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/videoFinish?";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (ref !== undefined && ref !== null)
            url_ += "ref=" + encodeURIComponent("" + ref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecordModuleResourceVideoFinish(_response));
        });
    }

    protected processRecordModuleResourceVideoFinish(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    recordModuleResourceModuleComplete(moduleId: number, ref: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/complete?";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (ref !== undefined && ref !== null)
            url_ += "ref=" + encodeURIComponent("" + ref) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecordModuleResourceModuleComplete(_response));
        });
    }

    protected processRecordModuleResourceModuleComplete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getModuleResource(moduleId: number, resourceId: number): Promise<ModuleResource> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/{resourceId}";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetModuleResource(_response));
        });
    }

    protected processGetModuleResource(response: Response): Promise<ModuleResource> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModuleResource.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleResource>(<any>null);
    }

    saveResourceData(moduleId: number, resourceId: number, data: { [key: string]: any; }): Promise<void> {
        let url_ = this.baseUrl + "/api/modules/{moduleId}/{resourceId}";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveResourceData(_response));
        });
    }

    protected processSaveResourceData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class NotificationsClient extends BackendClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Router, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(): Promise<Notification[]> {
        let url_ = this.baseUrl + "/api/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<Notification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Notification.fromJS(item));
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Notification[]>(<any>null);
    }

    dismiss(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/notifications/{id}/dismiss";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDismiss(_response));
        });
    }

    protected processDismiss(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ProgressClient extends BackendClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Router, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProgress(): Promise<ProgressResponse> {
        let url_ = this.baseUrl + "/api/progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProgress(_response));
        });
    }

    protected processGetProgress(response: Response): Promise<ProgressResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProgressResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProgressResponse>(<any>null);
    }

    getLensValues(): Promise<LensProgressResponse> {
        let url_ = this.baseUrl + "/api/progress/lens";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLensValues(_response));
        });
    }

    protected processGetLensValues(response: Response): Promise<LensProgressResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LensProgressResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LensProgressResponse>(<any>null);
    }
}

export class SurveyClient extends BackendClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Router, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getSurvey(id: string | null): Promise<Survey> {
        let url_ = this.baseUrl + "/api/survey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSurvey(_response));
        });
    }

    protected processGetSurvey(response: Response): Promise<Survey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Survey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Survey>(<any>null);
    }

    newSurvey(id: string | null, survey: Survey): Promise<DbSurvey> {
        let url_ = this.baseUrl + "/api/survey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(survey);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNewSurvey(_response));
        });
    }

    protected processNewSurvey(response: Response): Promise<DbSurvey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DbSurvey.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DbSurvey>(<any>null);
    }

    reassess(moduleId: string | null): Promise<Survey> {
        let url_ = this.baseUrl + "/api/survey/{moduleId}/reassess";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReassess(_response));
        });
    }

    protected processReassess(response: Response): Promise<Survey> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Survey.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Survey>(<any>null);
    }

    reassessSubmit(moduleId: string | null, response: SurveyResponse): Promise<DbSurveyResponse> {
        let url_ = this.baseUrl + "/api/survey/{moduleId}/reassess";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReassessSubmit(_response));
        });
    }

    protected processReassessSubmit(response: Response): Promise<DbSurveyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DbSurveyResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DbSurveyResponse>(<any>null);
    }

    getUserSurvey(id: string | null | undefined, user: DbUser): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/survey?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <RequestInit>{
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserSurvey(_response));
        });
    }

    protected processGetUserSurvey(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    getAnswers(id: string | null): Promise<DbSurveyResponse> {
        let url_ = this.baseUrl + "/api/survey/{id}/answer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAnswers(_response));
        });
    }

    protected processGetAnswers(response: Response): Promise<DbSurveyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DbSurveyResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DbSurveyResponse>(<any>null);
    }

    answerSurvey(id: string | null, response: SurveyResponse): Promise<DbSurveyResponse> {
        let url_ = this.baseUrl + "/api/survey/{id}/answer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAnswerSurvey(_response));
        });
    }

    protected processAnswerSurvey(response: Response): Promise<DbSurveyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DbSurveyResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DbSurveyResponse>(<any>null);
    }
}

export class JwtAuthResult implements IJwtAuthResult {
    accessToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;

    constructor(data?: IJwtAuthResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"] ? RefreshToken.fromJS(_data["refreshToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JwtAuthResult {
        data = typeof data === 'object' ? data : {};
        let result = new JwtAuthResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken ? this.refreshToken.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IJwtAuthResult {
    accessToken?: string | undefined;
    refreshToken?: RefreshToken | undefined;
}

export class RefreshToken implements IRefreshToken {
    userName?: string | undefined;
    tokenString?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.tokenString = _data["tokenString"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshToken {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["tokenString"] = this.tokenString;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRefreshToken {
    userName?: string | undefined;
    tokenString?: string | undefined;
    expireAt?: Date;
}

export class LoginModel implements ILoginModel {
    username!: string;
    password!: string;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginModel {
    username: string;
    password: string;
}

export class RegisterModel implements IRegisterModel {
    /** The username of the user being registered. */
    username!: string;
    /** The email address of the user being registered. */
    email!: string;
    /** The password of the user being registered. */
    password!: string;
    /** The number of years of teaching experience the new user has. */
    yearsExperience!: number;
    /** The current role of the user. */
    role!: CurrentRole;
    /** The name of the teaching institution the new user works for. */
    institution?: string | undefined;
    /** The discipline the new user teaches. */
    discipline?: string | undefined;
    /** The optional gender identity of the new user. */
    gender?: Gender | undefined;

    constructor(data?: IRegisterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.yearsExperience = _data["yearsExperience"];
            this.role = _data["role"];
            this.institution = _data["institution"];
            this.discipline = _data["discipline"];
            this.gender = _data["gender"];
        }
    }

    static fromJS(data: any): RegisterModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["password"] = this.password;
        data["yearsExperience"] = this.yearsExperience;
        data["role"] = this.role;
        data["institution"] = this.institution;
        data["discipline"] = this.discipline;
        data["gender"] = this.gender;
        return data; 
    }
}

export interface IRegisterModel {
    /** The username of the user being registered. */
    username: string;
    /** The email address of the user being registered. */
    email: string;
    /** The password of the user being registered. */
    password: string;
    /** The number of years of teaching experience the new user has. */
    yearsExperience: number;
    /** The current role of the user. */
    role: CurrentRole;
    /** The name of the teaching institution the new user works for. */
    institution?: string | undefined;
    /** The discipline the new user teaches. */
    discipline?: string | undefined;
    /** The optional gender identity of the new user. */
    gender?: Gender | undefined;
}

export type CurrentRole = "Unknown" | "EngProf" | "StemProf" | "DeanDepHeadChair" | "EdDev" | "Other";

export type Gender = "NotSpecified" | "Female" | "Male" | "NonBinary" | "Other";

export class RefreshModel implements IRefreshModel {
    refreshToken!: string;

    constructor(data?: IRefreshModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data; 
    }
}

export interface IRefreshModel {
    refreshToken: string;
}

export class RedirectModel implements IRedirectModel {
    redirectUrl?: string | undefined;

    constructor(data?: IRedirectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): RedirectModel {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectUrl"] = this.redirectUrl;
        return data; 
    }
}

export interface IRedirectModel {
    redirectUrl?: string | undefined;
}

export class UserDashboard implements IUserDashboard {
    tutorial?: boolean;
    recommendedModules?: ModuleSummary[] | undefined;
    modulesByState?: { [key in DbModuleStates]?: ModuleSummary[]; } | undefined;

    constructor(data?: IUserDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tutorial = _data["tutorial"];
            if (Array.isArray(_data["recommendedModules"])) {
                this.recommendedModules = [] as any;
                for (let item of _data["recommendedModules"])
                    this.recommendedModules!.push(ModuleSummary.fromJS(item));
            }
            if (_data["modulesByState"]) {
                this.modulesByState = {} as any;
                for (let key in _data["modulesByState"]) {
                    if (_data["modulesByState"].hasOwnProperty(key))
                        this.modulesByState![key] = _data["modulesByState"][key] ? _data["modulesByState"][key].map((i: any) => ModuleSummary.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): UserDashboard {
        data = typeof data === 'object' ? data : {};
        let result = new UserDashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tutorial"] = this.tutorial;
        if (Array.isArray(this.recommendedModules)) {
            data["recommendedModules"] = [];
            for (let item of this.recommendedModules)
                data["recommendedModules"].push(item.toJSON());
        }
        if (this.modulesByState) {
            data["modulesByState"] = {};
            for (let key in this.modulesByState) {
                if (this.modulesByState.hasOwnProperty(key))
                    data["modulesByState"][key] = this.modulesByState[key];
            }
        }
        return data; 
    }
}

export interface IUserDashboard {
    tutorial?: boolean;
    recommendedModules?: ModuleSummary[] | undefined;
    modulesByState?: { [key in DbModuleStates]?: ModuleSummary[]; } | undefined;
}

export class ModuleSummary implements IModuleSummary {
    id?: number;
    /** A short name for this module. */
    name!: string;
    /** The threshold concept for this module. */
    thresholdConcept!: number;
    /** The expertise level for this module. */
    expertise!: Expertise;
    /** A longer description for this module. */
    description!: string;
    /** A URL pointing to a picture relevant to the module. */
    pictureUrl?: string | undefined;
    /** Whether the module has no action plan. */
    noActionPlan?: boolean;

    constructor(data?: IModuleSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.thresholdConcept = _data["thresholdConcept"];
            this.expertise = _data["expertise"];
            this.description = _data["description"];
            this.pictureUrl = _data["pictureUrl"];
            this.noActionPlan = _data["noActionPlan"];
        }
    }

    static fromJS(data: any): ModuleSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["thresholdConcept"] = this.thresholdConcept;
        data["expertise"] = this.expertise;
        data["description"] = this.description;
        data["pictureUrl"] = this.pictureUrl;
        data["noActionPlan"] = this.noActionPlan;
        return data; 
    }
}

export interface IModuleSummary {
    id?: number;
    /** A short name for this module. */
    name: string;
    /** The threshold concept for this module. */
    thresholdConcept: number;
    /** The expertise level for this module. */
    expertise: Expertise;
    /** A longer description for this module. */
    description: string;
    /** A URL pointing to a picture relevant to the module. */
    pictureUrl?: string | undefined;
    /** Whether the module has no action plan. */
    noActionPlan?: boolean;
}

export type Expertise = 0 | 1 | 2 | 3 | 4 | 5;

export type DbModuleStates = "Incomplete" | "InProgress" | "ActionPlanPending" | "ActionPlanComplete" | "ActionPlanReminded" | "ActionReviewPending" | "Complete" | "Unknown";

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export class Module extends ModuleSummary implements IModule {
    /** The full contents of the module. */
    contents!: ModuleContents;

    constructor(data?: IModule) {
        super(data);
        if (!data) {
            this.contents = new ModuleContents();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contents = _data["contents"] ? ModuleContents.fromJS(_data["contents"]) : new ModuleContents();
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contents"] = this.contents ? this.contents.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IModule extends IModuleSummary {
    /** The full contents of the module. */
    contents: ModuleContents;
}

export class ModuleContents implements IModuleContents {
    resources!: ModuleResource[];
    video!: ModuleVideo;

    constructor(data?: IModuleContents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resources = [];
            this.video = new ModuleVideo();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(ModuleResource.fromJS(item));
            }
            this.video = _data["video"] ? ModuleVideo.fromJS(_data["video"]) : new ModuleVideo();
        }
    }

    static fromJS(data: any): ModuleContents {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleContents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IModuleContents {
    resources: ModuleResource[];
    video: ModuleVideo;
}

export class ModuleResource implements IModuleResource {
    resourceId?: string | undefined;
    surtitle?: string | undefined;
    title!: string;
    subtitle?: string | undefined;
    sections!: ModuleSection[];
    backgroundColor?: string | undefined;
    color?: string | undefined;
    accentColor?: string | undefined;
    previousData?: { [key: string]: any; } | undefined;

    constructor(data?: IModuleResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.surtitle = _data["surtitle"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(ModuleSection.fromJS(item));
            }
            this.backgroundColor = _data["backgroundColor"];
            this.color = _data["color"];
            this.accentColor = _data["accentColor"];
            if (_data["previousData"]) {
                this.previousData = {} as any;
                for (let key in _data["previousData"]) {
                    if (_data["previousData"].hasOwnProperty(key))
                        this.previousData![key] = _data["previousData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ModuleResource {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["surtitle"] = this.surtitle;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        data["backgroundColor"] = this.backgroundColor;
        data["color"] = this.color;
        data["accentColor"] = this.accentColor;
        if (this.previousData) {
            data["previousData"] = {};
            for (let key in this.previousData) {
                if (this.previousData.hasOwnProperty(key))
                    data["previousData"][key] = this.previousData[key];
            }
        }
        return data; 
    }
}

export interface IModuleResource {
    resourceId?: string | undefined;
    surtitle?: string | undefined;
    title: string;
    subtitle?: string | undefined;
    sections: ModuleSection[];
    backgroundColor?: string | undefined;
    color?: string | undefined;
    accentColor?: string | undefined;
    previousData?: { [key: string]: any; } | undefined;
}

export class ModuleSection implements IModuleSection {
    icon?: string | undefined;
    title?: string | undefined;
    backgroundColor?: string | undefined;
    color?: string | undefined;
    accentColor?: string | undefined;
    dependsOn?: ModuleDependency | undefined;
    controls!: any[];

    constructor(data?: IModuleSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.controls = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.icon = _data["icon"];
            this.title = _data["title"];
            this.backgroundColor = _data["backgroundColor"];
            this.color = _data["color"];
            this.accentColor = _data["accentColor"];
            this.dependsOn = _data["dependsOn"] ? ModuleDependency.fromJS(_data["dependsOn"]) : <any>undefined;
            if (Array.isArray(_data["controls"])) {
                this.controls = [] as any;
                for (let item of _data["controls"])
                    this.controls!.push(item);
            }
        }
    }

    static fromJS(data: any): ModuleSection {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon;
        data["title"] = this.title;
        data["backgroundColor"] = this.backgroundColor;
        data["color"] = this.color;
        data["accentColor"] = this.accentColor;
        data["dependsOn"] = this.dependsOn ? this.dependsOn.toJSON() : <any>undefined;
        if (Array.isArray(this.controls)) {
            data["controls"] = [];
            for (let item of this.controls)
                data["controls"].push(item);
        }
        return data; 
    }
}

export interface IModuleSection {
    icon?: string | undefined;
    title?: string | undefined;
    backgroundColor?: string | undefined;
    color?: string | undefined;
    accentColor?: string | undefined;
    dependsOn?: ModuleDependency | undefined;
    controls: any[];
}

export class ModuleDependency implements IModuleDependency {
    id!: string;
    value?: any | undefined;

    constructor(data?: IModuleDependency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ModuleDependency {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleDependency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data; 
    }
}

export interface IModuleDependency {
    id: string;
    value?: any | undefined;
}

export class ModuleVideo implements IModuleVideo {
    src!: string;
    subtitles!: ModuleSubtitle[];
    resourceTriggers!: { [key: string]: ModuleResourceTrigger[]; };
    required?: boolean;

    constructor(data?: IModuleVideo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subtitles = [];
            this.resourceTriggers = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.src = _data["src"];
            if (Array.isArray(_data["subtitles"])) {
                this.subtitles = [] as any;
                for (let item of _data["subtitles"])
                    this.subtitles!.push(ModuleSubtitle.fromJS(item));
            }
            if (_data["resourceTriggers"]) {
                this.resourceTriggers = {} as any;
                for (let key in _data["resourceTriggers"]) {
                    if (_data["resourceTriggers"].hasOwnProperty(key))
                        this.resourceTriggers![key] = _data["resourceTriggers"][key] ? _data["resourceTriggers"][key].map((i: any) => ModuleResourceTrigger.fromJS(i)) : [];
                }
            }
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): ModuleVideo {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleVideo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["src"] = this.src;
        if (Array.isArray(this.subtitles)) {
            data["subtitles"] = [];
            for (let item of this.subtitles)
                data["subtitles"].push(item.toJSON());
        }
        if (this.resourceTriggers) {
            data["resourceTriggers"] = {};
            for (let key in this.resourceTriggers) {
                if (this.resourceTriggers.hasOwnProperty(key))
                    data["resourceTriggers"][key] = this.resourceTriggers[key];
            }
        }
        data["required"] = this.required;
        return data; 
    }
}

export interface IModuleVideo {
    src: string;
    subtitles: ModuleSubtitle[];
    resourceTriggers: { [key: string]: ModuleResourceTrigger[]; };
    required?: boolean;
}

export class ModuleSubtitle implements IModuleSubtitle {
    src!: string;
    lang?: string | undefined;
    label?: string | undefined;

    constructor(data?: IModuleSubtitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.src = _data["src"];
            this.lang = _data["lang"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ModuleSubtitle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleSubtitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["src"] = this.src;
        data["lang"] = this.lang;
        data["label"] = this.label;
        return data; 
    }
}

export interface IModuleSubtitle {
    src: string;
    lang?: string | undefined;
    label?: string | undefined;
}

export class ModuleResourceTrigger implements IModuleResourceTrigger {
    resourceId!: string;
    icon?: string | undefined;
    label?: string | undefined;

    constructor(data?: IModuleResourceTrigger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.icon = _data["icon"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ModuleResourceTrigger {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleResourceTrigger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["icon"] = this.icon;
        data["label"] = this.label;
        return data; 
    }
}

export interface IModuleResourceTrigger {
    resourceId: string;
    icon?: string | undefined;
    label?: string | undefined;
}

export class Notification implements INotification {
    id?: number;
    date?: Date;
    shortDescription?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    data?: any | undefined;

    constructor(data?: INotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        data["description"] = this.description;
        data["url"] = this.url;
        data["data"] = this.data;
        return data; 
    }
}

export interface INotification {
    id?: number;
    date?: Date;
    shortDescription?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    data?: any | undefined;
}

export class ProgressResponse implements IProgressResponse {
    flags?: { [key: string]: number; } | undefined;

    constructor(data?: IProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["flags"]) {
                this.flags = {} as any;
                for (let key in _data["flags"]) {
                    if (_data["flags"].hasOwnProperty(key))
                        this.flags![key] = _data["flags"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.flags) {
            data["flags"] = {};
            for (let key in this.flags) {
                if (this.flags.hasOwnProperty(key))
                    data["flags"][key] = this.flags[key];
            }
        }
        return data; 
    }
}

export interface IProgressResponse {
    flags?: { [key: string]: number; } | undefined;
}

export class LensProgressResponse implements ILensProgressResponse {
    values?: LensResponse[] | undefined;
    expertiseThresholds?: number[] | undefined;
    expertise?: Expertise;

    constructor(data?: ILensProgressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(LensResponse.fromJS(item));
            }
            if (Array.isArray(_data["expertiseThresholds"])) {
                this.expertiseThresholds = [] as any;
                for (let item of _data["expertiseThresholds"])
                    this.expertiseThresholds!.push(item);
            }
            this.expertise = _data["expertise"];
        }
    }

    static fromJS(data: any): LensProgressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LensProgressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (Array.isArray(this.expertiseThresholds)) {
            data["expertiseThresholds"] = [];
            for (let item of this.expertiseThresholds)
                data["expertiseThresholds"].push(item);
        }
        data["expertise"] = this.expertise;
        return data; 
    }
}

export interface ILensProgressResponse {
    values?: LensResponse[] | undefined;
    expertiseThresholds?: number[] | undefined;
    expertise?: Expertise;
}

export class LensResponse implements ILensResponse {
    aspect?: LearningEnvironmentAspect | undefined;
    level?: number;
    offset?: number;

    constructor(data?: ILensResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aspect = _data["aspect"] ? LearningEnvironmentAspect.fromJS(_data["aspect"]) : <any>undefined;
            this.level = _data["level"];
            this.offset = _data["offset"];
        }
    }

    static fromJS(data: any): LensResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LensResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aspect"] = this.aspect ? this.aspect.toJSON() : <any>undefined;
        data["level"] = this.level;
        data["offset"] = this.offset;
        return data; 
    }
}

export interface ILensResponse {
    aspect?: LearningEnvironmentAspect | undefined;
    level?: number;
    offset?: number;
}

export class LearningEnvironmentAspect implements ILearningEnvironmentAspect {
    group?: string | undefined;
    id?: string | undefined;

    constructor(data?: ILearningEnvironmentAspect) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LearningEnvironmentAspect {
        data = typeof data === 'object' ? data : {};
        let result = new LearningEnvironmentAspect();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILearningEnvironmentAspect {
    group?: string | undefined;
    id?: string | undefined;
}

export class Survey implements ISurvey {
    title!: string;
    surveyId!: string;
    questions!: SurveyQuestion[];

    constructor(data?: ISurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.surveyId = _data["surveyId"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SurveyQuestion.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Survey {
        data = typeof data === 'object' ? data : {};
        let result = new Survey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["surveyId"] = this.surveyId;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISurvey {
    title: string;
    surveyId: string;
    questions: SurveyQuestion[];
}

export class SurveyQuestion implements ISurveyQuestion {
    question!: string;
    number!: number;
    type!: QuestionType;
    answers!: SurveyAnswer[];

    constructor(data?: ISurveyQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.answers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.number = _data["number"];
            this.type = _data["type"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["number"] = this.number;
        data["type"] = this.type;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISurveyQuestion {
    question: string;
    number: number;
    type: QuestionType;
    answers: SurveyAnswer[];
}

export type QuestionType = "single" | "multi" | "drag" | "text";

export class SurveyAnswer implements ISurveyAnswer {
    answer!: string;
    value!: number;

    constructor(data?: ISurveyAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answer = _data["answer"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SurveyAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["value"] = this.value;
        return data; 
    }
}

export interface ISurveyAnswer {
    answer: string;
    value: number;
}

/** The record of a user's responses to a survey. */
export class DbSurveyResponse implements IDbSurveyResponse {
    /** Primary Key */
    id?: number;
    /** The user responding to the survey. */
    user?: DbUser | undefined;
    /** The survey being responded to. */
    survey?: DbSurvey | undefined;
    /** The collection of responses from the user. */
    questionResponses?: DbSurveyQuestionResponse[] | undefined;

    constructor(data?: IDbSurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? DbUser.fromJS(_data["user"]) : <any>undefined;
            this.survey = _data["survey"] ? DbSurvey.fromJS(_data["survey"]) : <any>undefined;
            if (Array.isArray(_data["questionResponses"])) {
                this.questionResponses = [] as any;
                for (let item of _data["questionResponses"])
                    this.questionResponses!.push(DbSurveyQuestionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DbSurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DbSurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        if (Array.isArray(this.questionResponses)) {
            data["questionResponses"] = [];
            for (let item of this.questionResponses)
                data["questionResponses"].push(item.toJSON());
        }
        return data; 
    }
}

/** The record of a user's responses to a survey. */
export interface IDbSurveyResponse {
    /** Primary Key */
    id?: number;
    /** The user responding to the survey. */
    user?: DbUser | undefined;
    /** The survey being responded to. */
    survey?: DbSurvey | undefined;
    /** The collection of responses from the user. */
    questionResponses?: DbSurveyQuestionResponse[] | undefined;
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data; 
    }
}

export interface IIdentityUserOfString {
    id?: string | undefined;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: Date | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data; 
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export class DbUser extends IdentityUser implements IDbUser {
    yearsExperience?: number;
    institution?: string | undefined;
    discipline?: string | undefined;
    gender?: DbGender;
    role?: DbCurrentRole;
    flags?: DbFlag[] | undefined;
    moduleStates?: DbUserModuleState[] | undefined;
    resourceEvents?: DbModuleResourceEvent[] | undefined;
    resourceSubmissions?: DbModuleResourceSubmission[] | undefined;
    notifications?: DbNotification[] | undefined;

    constructor(data?: IDbUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.yearsExperience = _data["yearsExperience"];
            this.institution = _data["institution"];
            this.discipline = _data["discipline"];
            this.gender = _data["gender"];
            this.role = _data["role"];
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(DbFlag.fromJS(item));
            }
            if (Array.isArray(_data["moduleStates"])) {
                this.moduleStates = [] as any;
                for (let item of _data["moduleStates"])
                    this.moduleStates!.push(DbUserModuleState.fromJS(item));
            }
            if (Array.isArray(_data["resourceEvents"])) {
                this.resourceEvents = [] as any;
                for (let item of _data["resourceEvents"])
                    this.resourceEvents!.push(DbModuleResourceEvent.fromJS(item));
            }
            if (Array.isArray(_data["resourceSubmissions"])) {
                this.resourceSubmissions = [] as any;
                for (let item of _data["resourceSubmissions"])
                    this.resourceSubmissions!.push(DbModuleResourceSubmission.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(DbNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DbUser {
        data = typeof data === 'object' ? data : {};
        let result = new DbUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearsExperience"] = this.yearsExperience;
        data["institution"] = this.institution;
        data["discipline"] = this.discipline;
        data["gender"] = this.gender;
        data["role"] = this.role;
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        if (Array.isArray(this.moduleStates)) {
            data["moduleStates"] = [];
            for (let item of this.moduleStates)
                data["moduleStates"].push(item.toJSON());
        }
        if (Array.isArray(this.resourceEvents)) {
            data["resourceEvents"] = [];
            for (let item of this.resourceEvents)
                data["resourceEvents"].push(item.toJSON());
        }
        if (Array.isArray(this.resourceSubmissions)) {
            data["resourceSubmissions"] = [];
            for (let item of this.resourceSubmissions)
                data["resourceSubmissions"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }
}

export interface IDbUser extends IIdentityUser {
    yearsExperience?: number;
    institution?: string | undefined;
    discipline?: string | undefined;
    gender?: DbGender;
    role?: DbCurrentRole;
    flags?: DbFlag[] | undefined;
    moduleStates?: DbUserModuleState[] | undefined;
    resourceEvents?: DbModuleResourceEvent[] | undefined;
    resourceSubmissions?: DbModuleResourceSubmission[] | undefined;
    notifications?: DbNotification[] | undefined;
}

export type DbGender = 0 | 1 | 2 | 3 | 4;

export type DbCurrentRole = 0 | 1 | 2 | 3 | 4 | 5;

export class DbFlag implements IDbFlag {
    id?: number;
    user?: DbUser | undefined;
    name?: string | undefined;
    state?: number;
    data?: string | undefined;

    constructor(data?: IDbFlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? DbUser.fromJS(_data["user"]) : <any>undefined;
            this.name = _data["name"];
            this.state = _data["state"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DbFlag {
        data = typeof data === 'object' ? data : {};
        let result = new DbFlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["state"] = this.state;
        data["data"] = this.data;
        return data; 
    }
}

export interface IDbFlag {
    id?: number;
    user?: DbUser | undefined;
    name?: string | undefined;
    state?: number;
    data?: string | undefined;
}

export class DbUserModuleState implements IDbUserModuleState {
    id?: number;
    state?: DbModuleStates;
    planLevel?: number | undefined;
    planStart?: Date | undefined;
    dbUserId!: string;
    user!: DbUser;
    dbModuleDescriptorId?: number;
    moduleDescriptor?: DbModuleDescriptor | undefined;
    firstVisitTrigger?: string | undefined;

    constructor(data?: IDbUserModuleState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new DbUser();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.planLevel = _data["planLevel"];
            this.planStart = _data["planStart"] ? new Date(_data["planStart"].toString()) : <any>undefined;
            this.dbUserId = _data["dbUserId"];
            this.user = _data["user"] ? DbUser.fromJS(_data["user"]) : new DbUser();
            this.dbModuleDescriptorId = _data["dbModuleDescriptorId"];
            this.moduleDescriptor = _data["moduleDescriptor"] ? DbModuleDescriptor.fromJS(_data["moduleDescriptor"]) : <any>undefined;
            this.firstVisitTrigger = _data["firstVisitTrigger"];
        }
    }

    static fromJS(data: any): DbUserModuleState {
        data = typeof data === 'object' ? data : {};
        let result = new DbUserModuleState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["planLevel"] = this.planLevel;
        data["planStart"] = this.planStart ? this.planStart.toISOString() : <any>undefined;
        data["dbUserId"] = this.dbUserId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["dbModuleDescriptorId"] = this.dbModuleDescriptorId;
        data["moduleDescriptor"] = this.moduleDescriptor ? this.moduleDescriptor.toJSON() : <any>undefined;
        data["firstVisitTrigger"] = this.firstVisitTrigger;
        return data; 
    }
}

export interface IDbUserModuleState {
    id?: number;
    state?: DbModuleStates;
    planLevel?: number | undefined;
    planStart?: Date | undefined;
    dbUserId: string;
    user: DbUser;
    dbModuleDescriptorId?: number;
    moduleDescriptor?: DbModuleDescriptor | undefined;
    firstVisitTrigger?: string | undefined;
}

export class DbModuleDescriptor implements IDbModuleDescriptor {
    /** Unique database ID (pk). */
    id?: number;
    /** The ID of the threshold concept for this module. */
    thresholdConceptId?: number;
    /** The expertise level for this module. */
    expertise?: Expertise;
    /** The unique number identifying this module within the threshold concept + expertise pairing. */
    number?: number;
    /** A short name for this module. */
    name?: string | undefined;
    /** A longer description for this module. */
    description?: string | undefined;
    pictureUrl?: string | undefined;
    noActionPlan?: boolean;
    contents?: DbModuleContents | undefined;
    userStates?: DbUserModuleState[] | undefined;

    constructor(data?: IDbModuleDescriptor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.thresholdConceptId = _data["thresholdConceptId"];
            this.expertise = _data["expertise"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.pictureUrl = _data["pictureUrl"];
            this.noActionPlan = _data["noActionPlan"];
            this.contents = _data["contents"] ? DbModuleContents.fromJS(_data["contents"]) : <any>undefined;
            if (Array.isArray(_data["userStates"])) {
                this.userStates = [] as any;
                for (let item of _data["userStates"])
                    this.userStates!.push(DbUserModuleState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DbModuleDescriptor {
        data = typeof data === 'object' ? data : {};
        let result = new DbModuleDescriptor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["thresholdConceptId"] = this.thresholdConceptId;
        data["expertise"] = this.expertise;
        data["number"] = this.number;
        data["name"] = this.name;
        data["description"] = this.description;
        data["pictureUrl"] = this.pictureUrl;
        data["noActionPlan"] = this.noActionPlan;
        data["contents"] = this.contents ? this.contents.toJSON() : <any>undefined;
        if (Array.isArray(this.userStates)) {
            data["userStates"] = [];
            for (let item of this.userStates)
                data["userStates"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDbModuleDescriptor {
    /** Unique database ID (pk). */
    id?: number;
    /** The ID of the threshold concept for this module. */
    thresholdConceptId?: number;
    /** The expertise level for this module. */
    expertise?: Expertise;
    /** The unique number identifying this module within the threshold concept + expertise pairing. */
    number?: number;
    /** A short name for this module. */
    name?: string | undefined;
    /** A longer description for this module. */
    description?: string | undefined;
    pictureUrl?: string | undefined;
    noActionPlan?: boolean;
    contents?: DbModuleContents | undefined;
    userStates?: DbUserModuleState[] | undefined;
}

export class DbModuleContents implements IDbModuleContents {
    /** Unique database ID (pk). */
    id?: number;
    /** The JSON blob describing the model. */
    contents?: string | undefined;

    constructor(data?: IDbModuleContents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contents = _data["contents"];
        }
    }

    static fromJS(data: any): DbModuleContents {
        data = typeof data === 'object' ? data : {};
        let result = new DbModuleContents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contents"] = this.contents;
        return data; 
    }
}

export interface IDbModuleContents {
    /** Unique database ID (pk). */
    id?: number;
    /** The JSON blob describing the model. */
    contents?: string | undefined;
}

export class DbModuleResourceEvent implements IDbModuleResourceEvent {
    id?: number;
    module!: DbModuleDescriptor;
    resourceId!: string;
    eventType!: ResourceEventType;
    eventTime!: Date;
    origin?: string | undefined;

    constructor(data?: IDbModuleResourceEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.module = new DbModuleDescriptor();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.module = _data["module"] ? DbModuleDescriptor.fromJS(_data["module"]) : new DbModuleDescriptor();
            this.resourceId = _data["resourceId"];
            this.eventType = _data["eventType"];
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>undefined;
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): DbModuleResourceEvent {
        data = typeof data === 'object' ? data : {};
        let result = new DbModuleResourceEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["resourceId"] = this.resourceId;
        data["eventType"] = this.eventType;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["origin"] = this.origin;
        return data; 
    }
}

export interface IDbModuleResourceEvent {
    id?: number;
    module: DbModuleDescriptor;
    resourceId: string;
    eventType: ResourceEventType;
    eventTime: Date;
    origin?: string | undefined;
}

export type ResourceEventType = 0 | 1 | 2 | 3 | 4;

export abstract class BaseEntity implements IBaseEntity {
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IBaseEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BaseEntity {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseEntity' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IBaseEntity {
    createdAt?: Date;
    updatedAt?: Date;
}

export class DbModuleResourceSubmission extends BaseEntity implements IDbModuleResourceSubmission {
    id?: number;
    module?: DbModuleDescriptor | undefined;
    resourceId?: string | undefined;
    submissionEvent?: DbModuleResourceEvent | undefined;
    data?: string | undefined;

    constructor(data?: IDbModuleResourceSubmission) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.module = _data["module"] ? DbModuleDescriptor.fromJS(_data["module"]) : <any>undefined;
            this.resourceId = _data["resourceId"];
            this.submissionEvent = _data["submissionEvent"] ? DbModuleResourceEvent.fromJS(_data["submissionEvent"]) : <any>undefined;
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DbModuleResourceSubmission {
        data = typeof data === 'object' ? data : {};
        let result = new DbModuleResourceSubmission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["resourceId"] = this.resourceId;
        data["submissionEvent"] = this.submissionEvent ? this.submissionEvent.toJSON() : <any>undefined;
        data["data"] = this.data;
        super.toJSON(data);
        return data; 
    }
}

export interface IDbModuleResourceSubmission extends IBaseEntity {
    id?: number;
    module?: DbModuleDescriptor | undefined;
    resourceId?: string | undefined;
    submissionEvent?: DbModuleResourceEvent | undefined;
    data?: string | undefined;
}

export class DbNotification extends BaseEntity implements IDbNotification {
    id?: number;
    user!: DbUser;
    state!: DbNotificationState;
    moduleId?: number | undefined;
    module?: DbModuleDescriptor | undefined;
    shortDescription!: string;
    description?: string | undefined;
    actionLink?: string | undefined;
    metadata?: string | undefined;

    constructor(data?: IDbNotification) {
        super(data);
        if (!data) {
            this.user = new DbUser();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? DbUser.fromJS(_data["user"]) : new DbUser();
            this.state = _data["state"];
            this.moduleId = _data["moduleId"];
            this.module = _data["module"] ? DbModuleDescriptor.fromJS(_data["module"]) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
            this.description = _data["description"];
            this.actionLink = _data["actionLink"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): DbNotification {
        data = typeof data === 'object' ? data : {};
        let result = new DbNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["moduleId"] = this.moduleId;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        data["description"] = this.description;
        data["actionLink"] = this.actionLink;
        data["metadata"] = this.metadata;
        super.toJSON(data);
        return data; 
    }
}

export interface IDbNotification extends IBaseEntity {
    id?: number;
    user: DbUser;
    state: DbNotificationState;
    moduleId?: number | undefined;
    module?: DbModuleDescriptor | undefined;
    shortDescription: string;
    description?: string | undefined;
    actionLink?: string | undefined;
    metadata?: string | undefined;
}

export type DbNotificationState = 0 | 1;

/** A database record of a survey and its questions. */
export class DbSurvey implements IDbSurvey {
    /** Unique Database ID (Primary Key) */
    id?: number;
    /** User facing unique ID */
    surveyId?: string | undefined;
    /** Title of the survey. */
    title?: string | undefined;
    /** The collection of questions in the survey. */
    questions?: DbSurveyQuestion[] | undefined;
    orderMatters?: boolean;

    constructor(data?: IDbSurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.surveyId = _data["surveyId"];
            this.title = _data["title"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(DbSurveyQuestion.fromJS(item));
            }
            this.orderMatters = _data["orderMatters"];
        }
    }

    static fromJS(data: any): DbSurvey {
        data = typeof data === 'object' ? data : {};
        let result = new DbSurvey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["surveyId"] = this.surveyId;
        data["title"] = this.title;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        data["orderMatters"] = this.orderMatters;
        return data; 
    }
}

/** A database record of a survey and its questions. */
export interface IDbSurvey {
    /** Unique Database ID (Primary Key) */
    id?: number;
    /** User facing unique ID */
    surveyId?: string | undefined;
    /** Title of the survey. */
    title?: string | undefined;
    /** The collection of questions in the survey. */
    questions?: DbSurveyQuestion[] | undefined;
    orderMatters?: boolean;
}

/** The DB model for a single question in a survey. */
export class DbSurveyQuestion implements IDbSurveyQuestion {
    /** Primary Key */
    id?: number;
    /** Question text */
    question?: string | undefined;
    /** Question Number */
    number?: number;
    /** The style of question */
    type?: DbQuestionType;
    /** Whether the question is skippable */
    optional?: boolean;
    /** The available answers for this question */
    answers?: DbSurveyAnswer[] | undefined;

    constructor(data?: IDbSurveyQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.question = _data["question"];
            this.number = _data["number"];
            this.type = _data["type"];
            this.optional = _data["optional"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(DbSurveyAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DbSurveyQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new DbSurveyQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["question"] = this.question;
        data["number"] = this.number;
        data["type"] = this.type;
        data["optional"] = this.optional;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

/** The DB model for a single question in a survey. */
export interface IDbSurveyQuestion {
    /** Primary Key */
    id?: number;
    /** Question text */
    question?: string | undefined;
    /** Question Number */
    number?: number;
    /** The style of question */
    type?: DbQuestionType;
    /** Whether the question is skippable */
    optional?: boolean;
    /** The available answers for this question */
    answers?: DbSurveyAnswer[] | undefined;
}

/** The types of questions that a survey can have. */
export type DbQuestionType = 0 | 1 | 2 | 3;

/** A predefined answer for a survey question. */
export class DbSurveyAnswer implements IDbSurveyAnswer {
    /** Primary key */
    id?: number;
    /** The answer text. */
    answer?: string | undefined;
    /** The identifying value of the answer. */
    value?: number;
    /** The ordering index of the answer. */
    order?: number;

    constructor(data?: IDbSurveyAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answer = _data["answer"];
            this.value = _data["value"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): DbSurveyAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new DbSurveyAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answer"] = this.answer;
        data["value"] = this.value;
        data["order"] = this.order;
        return data; 
    }
}

/** A predefined answer for a survey question. */
export interface IDbSurveyAnswer {
    /** Primary key */
    id?: number;
    /** The answer text. */
    answer?: string | undefined;
    /** The identifying value of the answer. */
    value?: number;
    /** The ordering index of the answer. */
    order?: number;
}

/** A record of a user's response to a survey question. */
export class DbSurveyQuestionResponse implements IDbSurveyQuestionResponse {
    /** Primary Key */
    id?: number;
    /** The question this response corresponds to */
    question?: DbSurveyQuestion | undefined;
    /** The ordered collection of answers to the question. */
    answers?: DbSurveyResponseAnswer[] | undefined;

    constructor(data?: IDbSurveyQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.question = _data["question"] ? DbSurveyQuestion.fromJS(_data["question"]) : <any>undefined;
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(DbSurveyResponseAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DbSurveyQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DbSurveyQuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

/** A record of a user's response to a survey question. */
export interface IDbSurveyQuestionResponse {
    /** Primary Key */
    id?: number;
    /** The question this response corresponds to */
    question?: DbSurveyQuestion | undefined;
    /** The ordered collection of answers to the question. */
    answers?: DbSurveyResponseAnswer[] | undefined;
}

export class DbSurveyResponseAnswer implements IDbSurveyResponseAnswer {
    id?: number;
    order?: number;
    answer?: string | undefined;

    constructor(data?: IDbSurveyResponseAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): DbSurveyResponseAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new DbSurveyResponseAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["answer"] = this.answer;
        return data; 
    }
}

export interface IDbSurveyResponseAnswer {
    id?: number;
    order?: number;
    answer?: string | undefined;
}

export class SurveyResponse implements ISurveyResponse {
    questions!: SurveyQuestionResponse[];

    constructor(data?: ISurveyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SurveyQuestionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISurveyResponse {
    questions: SurveyQuestionResponse[];
}

export class SurveyQuestionResponse implements ISurveyQuestionResponse {
    number?: number;
    selectedAnswers!: SurveyResponseAnswer[];

    constructor(data?: ISurveyQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedAnswers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            if (Array.isArray(_data["selectedAnswers"])) {
                this.selectedAnswers = [] as any;
                for (let item of _data["selectedAnswers"])
                    this.selectedAnswers!.push(SurveyResponseAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        if (Array.isArray(this.selectedAnswers)) {
            data["selectedAnswers"] = [];
            for (let item of this.selectedAnswers)
                data["selectedAnswers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISurveyQuestionResponse {
    number?: number;
    selectedAnswers: SurveyResponseAnswer[];
}

export class SurveyResponseAnswer implements ISurveyResponseAnswer {
    value!: any;

    constructor(data?: ISurveyResponseAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SurveyResponseAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResponseAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }
}

export interface ISurveyResponseAnswer {
    value: any;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class RequestRedirectError extends Error
{
    constructor(path: string) {
        super(`Request interrupted by redirect to ${path}`)
    }
}

export async function CaptureRedirectError<T>(func: () => Promise<T>): Promise<T | null> {
    try {
        return await func();
    } catch (e) {
        if (e instanceof(RequestRedirectError)) {
            return null;
        }

        throw e;
    }
}